import { IonIcon } from '@ionic/react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useHouseName } from '../../hooks/HouseHooks';
import { ProfileCard } from '../profile/ProfileCard';
import { QRCodeSVG } from 'qrcode.react';
import { User } from '../../model/models';

interface IdenfiticationProps {
  slug: string;
  user?: User;
  isLoading: boolean;
}

const Identification: React.FC<IdenfiticationProps> = ({
  slug,
  user,
  isLoading,
}: IdenfiticationProps) => {
  const houseName = useHouseName();

  return (
    <div className="rounded-t-3xl bg-white h-full modal-profile-content py-20 px-6 md:rounded-3xl overflow-scroll">
      <div className="center flex flex-col items-center lg:w-3/4 lg:mx-auto">
        <div className="flex w-14 h-14 inset-4 justify-center items-center border border-transparent rounded-full text-white bg-primary">
          <IonIcon
            slot="icon-only"
            className="w-7 h-7 stroke-white ios hydrated"
            src="./assets/nav/card.svg"
          />
        </div>
        <h1 className="font-semibold text-xl mt-4 text-black">
          <FormattedMessage id="Identification" />
        </h1>
        <p className="text-sm text-gray-500 text-center w-4/5 mt-2">
          <FormattedMessage id="Show your resident card in case of control, and scan one QR codes to access the facilities." />
        </p>
      </div>
      {user ? (
        <>
          <div className={`flex justify-center gap-3 mt-8 md:mx-auto md:w-104`}>
            <Link
              to={'/my-identity/identification'}
              className={`flex flex-col justify-center items-center px-4 py-5 rounded-2xl text-xs font-medium break-words text-center leading-3 w-1/3 ${
                slug === 'identification'
                  ? 'bg-primary text-white'
                  : 'bg-tertiary text-gray-500 bg-opacity-25'
              }`}
            >
              <IonIcon
                slot="icon-only"
                className="w-7 h-7 mb-3 stroke-white ios hydrated"
                src="./assets/nav/card.svg"
              />
              <FormattedMessage id="Identification card" />
            </Link>
            {user.qrcode?.identification.url &&
              user.qrcode?.identification.url !== '' && (
                <Link
                  to={'/my-identity/qr-identification'}
                  className={`flex flex-col justify-center items-center px-4 py-5 rounded-2xl text-xs font-medium break-words text-center leading-3 w-1/3 ${
                    slug === 'qr-identification'
                      ? 'bg-primary text-white'
                      : 'bg-tertiary text-gray-500 bg-opacity-25'
                  }`}
                >
                  <IonIcon
                    slot="icon-only"
                    className="w-7 h-7 mb-3 stroke-white ios hydrated"
                    src="./assets/img/qr-id.svg"
                  />
                  <FormattedMessage id="QR code Identification" />
                </Link>
              )}
            {user.qrcode?.sport && user.qrcode.sport?.url !== '' && (
              <Link
                to={'/my-identity/qr-sport'}
                className={`flex flex-col justify-center items-center px-4 py-5 rounded-2xl text-xs font-medium break-words text-center leading-3 w-1/3 ${
                  slug === 'qr-sport'
                    ? 'bg-primary text-white'
                    : 'bg-tertiary text-gray-500 bg-opacity-25'
                }`}
              >
                <IonIcon
                  slot="icon-only"
                  className="w-7 h-7 mb-3 stroke-white ios hydrated"
                  src="./assets/img/qr-sport.svg"
                />
                <FormattedMessage id="Sports QR code" />
              </Link>
            )}
          </div>
          <div className="flex justify-center my-10 md:w-104 md:mx-auto">
            {slug === 'identification' && (
              <div className="w-full bg-lightGrey overflow-hidden shadow rounded-3xl">
                <ProfileCard user={user} houseName={houseName} />
              </div>
            )}
            {slug === 'qr-identification' &&
              user.qrcode?.identification.url &&
              user.qrcode?.identification.url !== '' && (
                <div className="flex flex-col items-center">
                  <div className="w-44 h-44 mt-4">
                    <QRCodeSVG
                      value={user.qrcode?.identification.url}
                      size={176}
                    />
                  </div>
                  <div className="mt-8">
                    <h3 className="font-medium text-center text-black">
                      <span className="uppercase mr-1">{user.last_name}</span>
                      {user.first_name}
                    </h3>
                    <p className="text-sm text-gray-500 text-center">
                      <FormattedMessage id="QR code identification" />
                    </p>
                  </div>
                </div>
              )}
            {user.qrcode?.sport &&
              user.qrcode?.sport?.url !== '' &&
              slug === 'qr-sport' && (
                <div className="flex flex-col items-center">
                  <div className="w-44 h-44 mt-4">
                    <QRCodeSVG value={user.qrcode.sport.url} size={176} />
                  </div>
                  <div className="mt-8">
                    <h3 className="font-medium text-center text-black">
                      <span className="uppercase mr-1">{user.last_name}</span>
                      {user.first_name}
                    </h3>
                    <p className="text-sm text-gray-500 text-center">
                      <FormattedMessage id="QR code sports offer" />
                    </p>
                  </div>
                </div>
              )}
          </div>
        </>
      ) : (
        <div className="center flex flex-col items-center mt-6">
          <FormattedMessage id={isLoading ? 'Loading' : 'Unavailable Datas'} />
        </div>
      )}
    </div>
  );
};

export default Identification;
